import axios, { AxiosInstance } from 'axios';

// backend has set up a global prefix for every endpoint
export const API_DOMAIN = '/api';

class Axios {
	instance: AxiosInstance;

	constructor() {
		this.instance = axios.create({
			baseURL: API_DOMAIN,
		});
	}

	refreshRequestHandler(token: string | null) {
		this.instance = axios.create({
			baseURL: API_DOMAIN,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
	}
}

export default new Axios();
